import {
  LOADER,
  MODAL
} from '../../reduxs'

import actionTypes from './holidayActionType'
import apiService from '../apiService'

export const getListHoliday = (param) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v1/getlist_holiday', param).then((res) => {
      if (res.status) {
        dispatch(saveListHoliday(res.data.list))
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getListOrder', res)
      }
    })
  }
}

export const getSidebarHolidays = (params) => {
  return (dispatch) => {
    return apiService.get('rest/v1/getlist_holiday', params).then((res) => {
      if (res.status) {
        dispatch(saveSideBarHolidays(res.data.list))
      } else {
        console.error('ERROR ACTION getListOrder', res)
      }
    })
  }
}

export const saveListHoliday = (data) => {
  return {
    type: actionTypes.SAVE_LIST_ALL_HOLIDAY,
    data
  }
}

export const saveSideBarHolidays = (data) => {
  return {
    type: actionTypes.SAVE_SIDE_BAR_HOLIDAYS,
    data,
  }
}
